import { render, staticRenderFns } from "./DesktopBetaContainer.vue?vue&type=template&id=5bbf8dd3&scoped=true"
import script from "./DesktopBetaContainer.vue?vue&type=script&lang=ts"
export * from "./DesktopBetaContainer.vue?vue&type=script&lang=ts"
import style0 from "./DesktopBetaContainer.vue?vue&type=style&index=0&id=5bbf8dd3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf8dd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbf8dd3')) {
      api.createRecord('5bbf8dd3', component.options)
    } else {
      api.reload('5bbf8dd3', component.options)
    }
    module.hot.accept("./DesktopBetaContainer.vue?vue&type=template&id=5bbf8dd3&scoped=true", function () {
      api.rerender('5bbf8dd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/DesktopBetaContainer.vue"
export default component.exports